export * from "/builds/dd3tech/wiggot/wiggot-web/packages/web-components/store/modals-portals/modal-m3.store.ts"